import script from "./AdminBackups.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminBackups.vue?vue&type=script&setup=true&lang=js"

import "./AdminBackups.vue?vue&type=style&index=0&id=692b8762&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-692b8762"]])

export default __exports__